/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

export const GET_PROVISIONED_APPLICATIONS = 'GET_PROVISIONED_APPLICATIONS';
export const GET_CALENDAR_EVENTS = 'GET_CALENDAR_EVENTS';
export const GET_PROJECTED_SENDS = 'GET_PROJECTED_SENDS';
export const GET_CAMPAIGNS = 'GET_CAMPAIGNS';
export const GET_LOCALIZATIONS = 'GET_LOCALIZATIONS';
export const GET_RECENT_AUTOMATIONS_RUN = 'GET_RECENT_AUTOMATIONS_RUN';
export const GET_RECENT_EMAILS_EDITED = 'GET_RECENT_EMAILS_EDITED';
export const GET_RECENT_EMAILS_SENT = 'GET_RECENT_EMAILS_SENT';
export const GET_RECENT_JOURNEYS_EDITED = 'GET_RECENT_JOURNEYS_EDITED';
export const GET_SALESFORCE_BLOG_POSTS = 'GET_SALESFORCE_BLOG_POSTS';
export const GET_USER_INFO = 'GET_USER_INFO';
export const HAS_CALENDAR_ACCESS = 'HAS_CALENDAR_ACCESS';
export const HAS_JOURNEY_BUILDER_CREATE = 'HAS_JOURNEY_BUILDER_CREATE';
export const HAS_JOURNEY_BUILDER_BR = 'HAS_JOURNEY_BUILDER_BR';
export const GET_JOURNEY_BUILDER_TEMPLATES = 'GET_JOURNEY_BUILDER_TEMPLATES';
export const HAS_JOURNEY_BUILDER_ACCESS = 'HAS_JOURNEY_BUILDER_ACCESS';
export const HAS_AUTOMATION_STUDIO_ACCESS = 'HAS_AUTOMATION_STUDIO_ACCESS';
export const HAS_EMAIL_STUDIO_ACCESS = 'HAS_EMAIL_STUDIO_ACCESS';
export const HAS_EMAIL_STUDIO_TRACKING_ACCESS = 'HAS_EMAIL_STUDIO_TRACKING_ACCESS';
export const HAS_CONTENT_BUILDER_ACCESS = 'HAS_CONTENT_BUILDER_ACCESS';
export const HAS_ADMINISTRATION_ACCESS = 'HAS_ADMINISTRATION_ACCESS';
export const OPEN_WELCOME_MAT = 'OPEN_WELCOME_MAT';
export const CLOSE_WELCOME_MAT = 'CLOSE_WELCOME_MAT';
export const CHECK_WELCOME_MAT = 'CHECK_WELCOME_MAT';
export const HAS_LIGHTNING_HOMEPAGE_BR = 'HAS_LIGHTNING_HOMEPAGE_BR';
export const JOURNEY_STATUS_DB_VALUE_MAP = {
  draft: 'draft',
  running: 'running',
  published: 'running',
  scheduledtopublish: 'running',
  unpublished: 'running',
  stopped: 'stopped',
  paused: 'paused',
  pausing: 'pausing',
  resuming: 'resuming',
};
export const LEGACY_MODE_FUEL = 'FUEL';
export const LEGACY_MODE_OPENRASTA = 'OPENRASTA';
